// the default is to use no optional modules
import { StoreDevtoolsModule } from '@ngrx/store-devtools'

export const optionalModules = [
  StoreDevtoolsModule.instrument({
    maxAge: 50,
  })
]
